import { render, staticRenderFns } from "./JoinCTA.vue?vue&type=template&id=7d35739e&scoped=true&"
import script from "./JoinCTA.vue?vue&type=script&lang=ts&"
export * from "./JoinCTA.vue?vue&type=script&lang=ts&"
import style0 from "./JoinCTA.vue?vue&type=style&index=0&id=7d35739e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d35739e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7d35739e', component.options)
    } else {
      api.reload('7d35739e', component.options)
    }
    module.hot.accept("./JoinCTA.vue?vue&type=template&id=7d35739e&scoped=true&", function () {
      api.rerender('7d35739e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/JoinCTA.vue"
export default component.exports